import React, { Component, type ErrorInfo, type ReactNode } from 'react';

type Props = { children: ReactNode };
type State = { error: Error | null };

/**
 * Без перехвата ошибок React может оставить пустой экран (особенно в Telegram WebView).
 */
export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('ErrorBoundary:', error, info.componentStack);
  }

  render() {
    if (this.state.error) {
      const msg = this.state.error.message || String(this.state.error);
      return (
        <div
          style={{
            minHeight: '100vh',
            boxSizing: 'border-box',
            padding: '24px 20px',
            background: 'var(--fc-bg)',
            color: 'var(--fc-text)',
            fontFamily: 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
            fontSize: 15,
            lineHeight: 1.45
          }}
        >
          <h1 style={{ fontSize: 18, fontWeight: 700, margin: '0 0 12px' }}>Не удалось открыть приложение</h1>
          <p style={{ margin: '0 0 14px', opacity: 0.92 }}>
            Закройте мини-апп и снова нажмите «Биржа» или «Открыть биржу» в боте. Если повторится — пришлите скрин этого
            текста в поддержку.
          </p>
          <pre
            style={{
              margin: 0,
              padding: 12,
              borderRadius: 10,
              background: 'rgba(255,255,255,0.06)',
              border: '1px solid rgba(255,255,255,0.1)',
              fontSize: 12,
              whiteSpace: 'pre-wrap',
              wordBreak: 'break-word'
            }}
          >
            {msg}
          </pre>
        </div>
      );
    }

    return this.props.children;
  }
}
